module.exports = __webpack_public_path__ + "bd.no1.9ad3df8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bd.no1.jpg
// module id = xmVF
// module chunks = 0